/* assets/rgd-cart-upsell-hook.js */
(function () {
  if (window.__RGD_CART_UPSELL_HOOK_V4__) return;
  window.__RGD_CART_UPSELL_HOOK_V4__ = true;

  var SECTION_HANDLE = 'rgd-cart-upsell';
  var TARGET_ID = 'RGDCartUpsell';

  var DEBUG = false;

  var inFlight = false;
  var lastRun = 0;
  var cooldownMs = 900;

  function dlog(){ if (!DEBUG) return; try { console.log.apply(console, arguments); } catch(e){} }
  function now(){ return Date.now ? Date.now() : new Date().getTime(); }

  function getPlaceholder(){ return document.getElementById(TARGET_ID); }
  function placeholderHasUpsell(el){ return el ? !!el.querySelector('.rgd-upsell') : false; }

  function canRun() {
    var t = now();
    if (inFlight) return false;
    if (t - lastRun < cooldownMs) return false;
    return true;
  }

  async function fetchSectionHTML() {
    var url = '/?sections=' + encodeURIComponent(SECTION_HANDLE);
    var r = await fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
    dlog('[RGD] sections status:', r.status);
    if (!r.ok) return '';
    var data = await r.json().catch(function(){ return null; });
    return (data && data[SECTION_HANDLE]) ? data[SECTION_HANDLE] : '';
  }

  function applyUpsellHTML(html) {
    var current = getPlaceholder();
    if (!current) {
      dlog('[RGD] #' + TARGET_ID + ' não existe no DOM.');
      return;
    }

    if (!html) {
      current.innerHTML = '';
      return;
    }

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newNode = doc.getElementById(TARGET_ID);
    if (!newNode) return;

    current.innerHTML = newNode.innerHTML;

    // ✅ depois de reinjetar, rebind do JS do upsell (asset)
    try {
      if (window.RGD_UpsellBestseller_init) window.RGD_UpsellBestseller_init();
    } catch(e){}
  }

  async function refreshUpsell(reason) {
    reason = reason || 'manual';

    var ph = getPlaceholder();
    if (!ph) { dlog('[RGD] refresh skip (sem placeholder).', reason); return; }

    if (reason === 'observer-empty' && placeholderHasUpsell(ph)) return;
    if (!canRun()) return;

    inFlight = true;
    lastRun = now();

    try {
      var html = await fetchSectionHTML();
      applyUpsellHTML(html);
    } catch(e) {
      console.error('[RGD] refreshUpsell error:', e);
    } finally {
      inFlight = false;
    }
  }

  // ✅ expõe pra outros scripts chamarem
  window.RGD_CartUpsell_refresh = refreshUpsell;

  var timer = null;
  function refreshUpsellDebounced(wait, reason) {
    wait = typeof wait === 'number' ? wait : 260;
    clearTimeout(timer);
    timer = setTimeout(function(){ refreshUpsell(reason || 'debounce'); }, wait);
  }

  // Hooks fetch/jQuery
  var _fetch = window.fetch;
  if (typeof _fetch === 'function') {
    window.fetch = function () {
      var input = arguments[0];
      var url = (input && input.url) ? input.url : input;
      url = (url || '').toString();

      var p = _fetch.apply(this, arguments);
      if (/\/cart\/(add|change|update)\.js(\?|$)/.test(url)) {
        p.finally(function(){ refreshUpsellDebounced(300, 'cart-fetch'); });
      }
      return p;
    };
  }

  if (window.jQuery && window.jQuery.ajax) {
    var _ajax = window.jQuery.ajax;
    window.jQuery.ajax = function () {
      var opts = arguments[0] || {};
      var url = (opts.url || '').toString();

      var jq = _ajax.apply(this, arguments);
      if (/\/cart\/(add|change|update)\.js(\?|$)/.test(url)) {
        jq.always(function(){ refreshUpsellDebounced(300, 'cart-ajax'); });
      }
      return jq;
    };
  }

  // Open drawer (ajuste os seletores se necessário)
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-cart-drawer-open], .site-header__cart, a[href="/cart"]');
    if (!btn) return;
    refreshUpsellDebounced(260, 'open-click');
    setTimeout(function(){ refreshUpsellDebounced(260, 'open-click-2'); }, 650);
    setTimeout(function(){ refreshUpsellDebounced(260, 'open-click-3'); }, 1400);
  });

  // Observer
  function findDrawerRoot() {
    return (
      document.getElementById('CartContainer') ||
      document.getElementById('CartDrawer') ||
      document.querySelector('.drawer__inner') ||
      null
    );
  }

  function bootObserverRetry() {
    var tries = 0;
    var max = 30;
    var iv = setInterval(function(){
      tries++;
      var root = findDrawerRoot();
      if (!root && tries < max) return;

      clearInterval(iv);

      if (!root) return;

      var mo = new MutationObserver(function(){
        var el = getPlaceholder();
        if (!el) return;
        var empty = (el.innerHTML || '').trim() === '';
        if (empty && !placeholderHasUpsell(el)) refreshUpsellDebounced(140, 'observer-empty');
      });

      mo.observe(root, { childList: true, subtree: true });

      refreshUpsellDebounced(220, 'boot');
      setTimeout(function(){ refreshUpsellDebounced(220, 'boot-2'); }, 650);
      setTimeout(function(){ refreshUpsellDebounced(220, 'boot-3'); }, 1400);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootObserverRetry);
  } else {
    bootObserverRetry();
  }
})();
